import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://sdmpay-dashboard-back.sdm.co/api' //  'https://axe-dev.securedigitalmarkets.com/api' //'https://axe-staging.securedigitalmarkets.com/api'  //https://axe-live.securedigitalmarkets.com/api
})

export default instance;
